export const ModelType = {
    User: 1,
    Club: 2,
    Event: 3,
    ParticipationClass: 4,
    AgeClass: 5,
    Participation: 6,
    EventProduct: 7,
    EventProductPurchase: 8,
    ParticipationAttempt: 9,
    ResultListGroup: 10,
    ResultList: 11,
    ParticipationList: 12,
    EventAcquisitionCampaign: 13,
    EventAcquisitionCampaignAcquirer: 14,
    Charge: 15,
    ChargeRefund: 16,
    FinisherPointsTransaction: 17,
    Activity: 18,
    EventRating: 19,
    PressDownloadCategory: 20,
    GuideSection: 22,
    GuidePage: 23,
    Achievement: 25,
    FinisherPointsCoupon: 26,
    FinisherPointsProductPurchase: 27,
    EventCouponPrintTemplate: 28,
    StarterNumberPrintTemplate: 29,
    Comment: 30,
    CancelCondition: 32,
    Price: 33,
    EventPage: 34,
    EventDescription: 35,
    EventRoleApplication: 36,
    EventUser: 37,
    Job: 38,
    Sponsor: 39,
    EventUserRole: 40,
    StageRace: 41,
    TrackSpot: 42,
    Track: 43,
    FinisherPointsProduct: 44,
    ParticipationCoupon: 45,
    SupportTicket: 46,
    ClubRole: 47,
    ClubMember: 48,
    Award: 49,
    Team: 50,
    Article: 55,
    GuideArea: 57,
    SportType: 58,
    BillingRequest: 59,
    BillingRequestGroup: 60,
    Verification: 61,
    EventTickerMessage: 62,
    Gallery: 63,
    GalleryMedia: 64,
    GalleryMediaPurchase: 65,
    MemberList: 66,
    PositionTag: 67,
    JobPosting: 68,
};
//# sourceMappingURL=ModelType.js.map